import * as FullStory from '@fullstory/browser';

const FullstoryPort = {
  add: function(app, orgId, devMode) {
    const requestAnimationFrame = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;

    app.ports.fullstoryPortInit.subscribe(function() {
      requestAnimationFrame(function() {
        FullStory.init({ orgId: orgId, devMode: devMode });
      });
    });
  }
}

module.exports = FullstoryPort;
